import { api } from "./api";
import { isV2 } from "./config";
import { getHardwareSnapshot, refreshHardware, setUpdateAvailable } from "./hardwareStore";

/**
 * Tells the server this terminal is alive and what state its printer is in (version, connection, last error, receipts waiting for a reprint),
 * so a manager sees a dead printer on the Terminals page before a customer notices. Never throws: a heartbeat must not disturb a sale.
 */
export async function sendHeartbeat(): Promise<void> {
  if (!isV2()) return;
  try {
    await refreshHardware();
    const h = getHardwareSnapshot();
    const r = await api.post<{ updateAvailable?: boolean }>("/terminals/heartbeat", {
      client: h.native ? "electron" : "web",
      appVersion: h.version ?? undefined,
      platform: typeof navigator !== "undefined" ? navigator.platform.slice(0, 40) : undefined,
      printer: h.native && h.status ? { connection: h.connection ?? undefined, state: h.status.state, lastError: h.status.lastError, lastOkAt: h.status.lastOkAt, failed: Math.min(h.status.failed, 999), paperWidth: h.paperWidth ?? undefined } : undefined,
      scannerOn: h.native ? h.scannerOn : undefined,
    });
    setUpdateAvailable(!!r.updateAvailable);
  } catch {
    /* offline or maintenance: the next beat will do */
  }
}

export function startHeartbeat(intervalMs = 3 * 60_000): () => void {
  void sendHeartbeat();
  const t = setInterval(() => void sendHeartbeat(), intervalMs);
  return () => clearInterval(t);
}
